import { MetadatoDocumento } from "src/app/common/form/documento/document-uploaded/campi";
import { TipoTipologica } from "src/app/common/models/tipologiche/tipo-tipologica";


export function mapToTipoTipologica(key?: any): TipoTipologica | undefined {
    if(typeof key !== 'string') return key;
    if (!key) return null;
    return { id: key, descrizione: '', label: '', rimosso: false };
};

export function mapToBoolean(param:any):boolean {
    if(typeof param === 'boolean') return param;
    const isYes = String(param).toLowerCase() === 'sì';
    return isYes;
}

export function mapToValue(obj: TipoTipologica) {
    if (!obj) return null;
    return obj.id;
}

export function mapBooleanToString(param:boolean):string {
    const isYes = param ? "Sì" : "No";
    return isYes;
}